const logoPaginaDofollow = 'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Sponsorship En Sintonía con tu Salud',
    annualPrice: 'Trimestral: 360',
    monthlyPrice: 120,
    features: [
      'Tres menciones en vivo: al entrar, en el desarrollo (aquí se explica tu marca) y salida',
      'Video comercial de 20 segundos durante el programa',
      'Presencia en transmisión en vivo por TNO Network',
      'Presencia en Web, App y Redes Sociales',
      'Asociación con salud preventiva y bienestar integral',
      logoPaginaDofollow,
    ],
    idealFor: 'Clínicas, laboratorios, marcas de wellness, nutrición y servicios de salud.',
    duration: 'Mensual',
    buttonText: 'Patrocinar En Sintonía con tu Salud',
    highlightedTitle: 'Salud multiplataforma',
    highlightedContent: [
      'Tu marca viaja con la credibilidad de la Dra. Grecia Andreina.',
      'Tres menciones + un comercial de 20 segundos dentro del programa.',
      'Prevención, bienestar y especialistas en un solo espacio.',
    ],
    highlightedButtonText: 'Ver programa en TNO',
  },
  {
    title: 'Segmento Exclusivo por Tema',
    annualPrice: 'Trimestral: 180',
    monthlyPrice: 60,
    features: [
      'Mención exclusiva: "Este segmento presentado por..."',
      'Vinculación con una temática: Prevención, Nutrición, Salud mental o Bienestar familiar',
      'Contenido alineado con el ADN de tu marca',
      'Presencia en el bloque correspondiente del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas especializadas que buscan relevancia temática en salud.',
    duration: 'Suscripción Mensual',
    buttonText: 'Elegir mi Tema',
    highlightedTitle: 'Autoridad en salud',
    highlightedContent: [
      'Tu marca se convierte en referente del segmento elegido.',
      'Asociación orgánica con bienestar y prevención.',
      'Ideal para campañas de concienciación y servicios médicos.',
    ],
    highlightedButtonText: 'Ver Temas Disponibles',
  },
  {
    title: 'Entrevista Patrocinada',
    annualPrice: 'Por sesión: 40',
    monthlyPrice: 40,
    features: [
      'Entrevista de 20 minutos en vivo',
      'Proyección de tus videos promocionales',
      'Mención de sedes, servicios o puntos de contacto',
      'Propuesta con respaldo visual en pantalla',
      'Post en redes sociales del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Médicos, clínicas, laboratorios y voceros de marcas de salud.',
    duration: '20 minutos por sesión',
    buttonText: 'Agendar Entrevista',
    highlightedTitle: 'Proyección y respaldo visual',
    highlightedContent: [
      'Proyección de videos promocionales durante la entrevista.',
      'Mención de oferta con respaldo en pantalla.',
    ],
    highlightedButtonText: 'Consultar Fechas',
  },
  {
    title: 'Post Patrocinado en TNO Digest',
    annualPrice: 'Por publicación: 50',
    monthlyPrice: 50,
    features: [
      'Publicación patrocinada en las redes sociales de TNO Digest',
      'Alcance en el ecosistema digital de En Sintonía con tu Salud y TNO Digest',
      'Contenido adaptado a salud y bienestar',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan visibilidad en redes sin compromiso de programa en vivo.',
    duration: 'Por publicación',
    buttonText: 'Solicitar Post Patrocinado',
    highlightedTitle: 'Visibilidad en TNO Digest',
    highlightedContent: [
      'Tu marca en el feed oficial de TNO Digest.',
      'Ideal para lanzamientos o reforzar una campaña de salud.',
    ],
    highlightedButtonText: 'Solicitar Post',
  },
  {
    title: 'Cápsula de Salud / Marca',
    annualPrice: 'Pack 5 Cápsulas: 150',
    monthlyPrice: 40,
    features: [
      'Cápsula de 60-90 segundos con estética del programa',
      'Distribución en redes sociales de TNO y del programa',
      'Tema: prevención, tips de salud o promoción de servicio',
      'Locución profesional en línea con el tono del show',
      logoPaginaDofollow,
    ],
    idealFor: 'Promociones de chequeos, suplementos o campañas de prevención.',
    duration: 'Por cápsula',
    buttonText: 'Solicitar Cápsula',
    highlightedTitle: 'Atención en Redes',
    highlightedContent: [
      'Tu mensaje en el ecosistema de En Sintonía con tu Salud.',
      'Formato breve y memorable para máxima recordación.',
    ],
    highlightedButtonText: 'Enviar mi Propuesta',
  },
  {
    title: 'UGC Salud y bienestar',
    annualPrice: '80 por pieza',
    monthlyPrice: 80,
    features: [
      'Video estilo testimonio o recomendación con el producto o servicio',
      'Demostración en contexto de autocuidado real',
      'Narrativa humana alineada con salud y prevención',
      'Publicación del video en TNO y en En Sintonía con tu Salud',
      'Entrega de archivo original para pauta publicitaria de la marca',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas de consumo saludable, suplementos, apps de salud y equipamiento.',
    duration: 'Por pieza',
    buttonText: 'Activar Campaña UGC',
    highlightedTitle: 'Prueba social en salud',
    highlightedContent: [
      'Contenido UGC con tono del programa y credibilidad de la ancla.',
      'Tu marca como recomendación de un aliado, no como anuncio frío.',
    ],
    highlightedButtonText: 'Activar Campaña UGC',
  },
];

export default optionsData;
